import * as Alert from './alert';
import { request } from './api';

/**
 * Action constants
 */
export const STOCKEXPOSURE_REQUEST = 'STOCKEXPOSURE_REQUEST';
export const STOCKEXPOSURE_SEARCH_REQUEST = 'STOCKEXPOSURE_SEARCH_REQUEST';
export const STOCKEXPOSURE_FETCH_REQUEST = 'STOCKEXPOSURE_FETCH_REQUEST';

export const STOCKEXPOSURE_FETCH_SUCCESS = 'STOCKEXPOSURE_FETCH_SUCCESS';
export const STOCKEXPOSURE_SEARCH_SUCCESS = 'STOCKEXPOSURE_SEARCH_SUCCESS';

export const STOCKEXPOSURE_CLEAR = 'STOCKEXPOSURE_CLEAR';
export const STOCKEXPOSURE_FAIL = 'STOCKEXPOSURE_FAIL';
export const STOCKEXPOSURE_PREV_SEARCH = 'STOCKEXPOSURE_PREV_SEARCH';
export const STOCKEXPOSURE_UPDATE_TOGGLE = 'STOCKEXPOSURE_UPDATE_TOGGLE';
export const STOCKEXPOSURE_SET_SELECTED_ACCOUNTS =
  'STOCKEXPOSURE_SET_SELECTED_ACCOUNTS';

/**
 * Action creators
 */
export function fetch(stock_tickers, accounts) {
  return (dispatch) => {
    dispatch({ type: STOCKEXPOSURE_FETCH_REQUEST, accounts, stock_tickers });

    return dispatch(
      request('post', `/accounts/stock-lookup/`, {
        body: { stock_tickers, accounts },
      })
    ).then(
      (data) => dispatch({ type: STOCKEXPOSURE_FETCH_SUCCESS, data }),
      (error) => {
        dispatch({ type: STOCKEXPOSURE_FAIL });

        return dispatch(Alert.show({ type: 'error', msg: parseErr(error) }));
      }
    );
  };
}

export function search(id) {
  return (dispatch) => {
    dispatch({ type: STOCKEXPOSURE_SEARCH_REQUEST });

    return dispatch(request('get', `/security/search/stock?term=${id}`)).then(
      (data) => dispatch({ type: STOCKEXPOSURE_SEARCH_SUCCESS, data }),
      (error) => {
        dispatch({ type: STOCKEXPOSURE_FAIL });

        return dispatch(Alert.show({ type: 'error', msg: parseErr(error) }));
      }
    );
  };
}

export function searchAll(id) {
  return (dispatch) => {
    dispatch({ type: STOCKEXPOSURE_REQUEST });

    return dispatch(request('get', `/security/search?term=${id}`)).then(
      (data) => dispatch({ type: STOCKEXPOSURE_SEARCH_SUCCESS, data }),
      (error) => {
        dispatch({ type: STOCKEXPOSURE_FAIL });

        return dispatch(Alert.show({ type: 'error', msg: parseErr(error) }));
      }
    );
  };
}
export function addPrevSearch(ticker) {
  return { type: STOCKEXPOSURE_PREV_SEARCH, ticker };
}

export function clear() {
  return (dispatch) => dispatch({ type: STOCKEXPOSURE_CLEAR });
}

export function clearSecurity() {
  return (dispatch) => dispatch({ type: STOCKEXPOSURE_CLEAR });
}

export function togglePercent(value) {
  return { type: STOCKEXPOSURE_UPDATE_TOGGLE, toggle: value };
}

export function setSelectedAccounts(accountIds) {
  return {
    type: STOCKEXPOSURE_SET_SELECTED_ACCOUNTS,
    accounts: accountIds,
  };
}

/**
 * Helper Functions
 */
function parseErr(err) {
  if (err.non_field_errors) {
    return err.non_field_errors[0];
  }

  return err.msg || err.detail || 'Failed to fetch stock exposure data.';
}
